import React, { useState, useCallback, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import UsageBanner from '../billing/UsageBanner';

const DashboardLayout = ({ children }) => {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const closeMobileSidebar = useCallback(() => setMobileSidebarOpen(false), []);
  const toggleMobileSidebar = useCallback(
    () => setMobileSidebarOpen((open) => !open),
    []
  );

  useEffect(() => {
    if (!mobileSidebarOpen) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [mobileSidebarOpen]);

  return (
    <div className={`dashboard-layout${mobileSidebarOpen ? ' sidebar-mobile-open' : ''}`}>
      <div
        className="sidebar-backdrop"
        aria-hidden={!mobileSidebarOpen}
        onClick={closeMobileSidebar}
      />
      <Sidebar
        mobileOpen={mobileSidebarOpen}
        onNavigate={closeMobileSidebar}
        onCloseMobile={closeMobileSidebar}
      />
      <div className="dashboard-main">
        <Header onMenuClick={toggleMobileSidebar} />
        <UsageBanner />
        <div className="dashboard-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
